const image1 = require("../../assets/images/misc/01.jpeg");
const image2 = require("../../assets/images/misc/02.jpeg");
const image3 = require("../../assets/images/misc/06.jpeg");
const image4 = require("../../assets/images/misc/04.jpeg");
const image5 = require("../../assets/images/misc/03.jpeg");

const Photos = () => {
    let rotations = [
        "rotate-2",
        "-rotate-2",
        "rotate-2",
        "rotate-2",
        "-rotate-2",
    ];

    return (
        <div className=" bg-white pt-8 pb-16">
            <div className="-my-4 flex justify-center flex-wrap gap-5 overflow-hidden sm:gap-10">
                {[image1, image2, image3, image4, image5].map(
                    (image, imageIndex) => (
                        <div
                            key={image.src}
                            className={
                                "relative aspect-[9/10] w-44 flex-none overflow-hidden rounded-xl bg-zinc-100 sm:w-60 sm:rounded-2xl dark:bg-zinc-800 " +
                                rotations[imageIndex % rotations.length] +
                                (imageIndex === 2 ? " hidden" : "")
                            }
                        >
                            <img
                                src={image}
                                alt=""
                                className="absolute inset-0 h-full w-full object-cover"
                            />
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default Photos;
